<div class="latest-export-container">
    <div class="latest-export-header">
        <strong>{{message['headerLatestExports']}}</strong>
        <button class="float-right button" (click)="minimizePanel($event)" [title]="message['buttonMinimizePanel']">
            <span class="vismaicon vismaicon-sm vismaicon-minimize-2" style="margin-left: 10px;"></span>
        </button>
        <button class="float-right button" [ngClass]="{'disabled': exports.length === 0}" [disabled]="exports.length === 0"
            (click)="exports.length !== 0 && clearAllExports($event)" [title]="message['buttonClearAll']">
            <span class="vismaicon vismaicon-square-x"></span>
        </button>
    </div>

    <div class="latest-export-wrapper">
        <ul class="latest-export-list">
            @if(exports.length === 0) {
            <li class="text-center">
                <p>{{message['infoNoExportsAvailable']}}</p>
            </li>
            } @else {
            @for(item of exports; track item.notificationId) {
            <li [ngClass]="{'new-export-item': item.isViewed === false}">
                <a href="#" (click)="downloadExport($event, item)" class="export-item" rel="noopener noreferrer">
                    <div class="export-item-container">
                        <div class="export-item-content">
                            <div class="margin-bottom-5">
                                {{item.content}}
                            </div>
                            <div class="font-size-9">
                                {{message['createdAt']}}: {{item.createdDateFormatted}} | {{message['expiresAt']}}:
                                {{item.deleteAfterFormatted}}
                            </div>
                        </div>
                    </div>
                </a>
                <button type="button" (click)="clearExport($event, item)" [title]="message['buttonRemove']"
                    class="button">
                    <span class="vismaicon vismaicon-sm vismaicon-cancel"></span>
                </button>
            </li>
            }
            }
        </ul>
    </div>
</div>